import React from "react";
import viewIcon from "../images/view-icon.svg";
import deleteIcon from "../images/delete-icon.svg";
import chatIcon from "../images/chatIcon.svg";

// Reusable Document Card Component
const DocumentCard = ({ item, onDelete, onView }) => {
  return (
    <div className="relative pb-[55px] min-h-[240px] max-w-sm relative docCol w-[24%] mx-[.5%] mb-[20px] bg-[#fff] rounded-[10px] shadow-md hover:shadow-lg">
      <div>
        <div className="text-[18px] bg-[#69afee] rounded-t-[10px] px-4 pt-2 pb-2 font-medium text-[#063056] text-ellipsis overflow-hidden w-[100%] border-b border[#fefefe] truncate">
          {item.doc_name}
        </div>
        <div className="px-4">
          <ul>
            <li className="mt-2 text-[#353535]">
              <span className="mr-1 text-[#000] font-medium">Doc Size:</span>
              {item?.doc_size}
            </li>
            <li className="mt-2 text-[#353535]">
              <span className="mr-1 text-[#000] font-medium">Upload Date:</span>
              {item?.upload_dt}
            </li>
          </ul>
        </div>
      </div>
      <div className="absolute border-t-2 border-t-[#efefef] pt-[5px] w-full bottom-0 pb-2 flex flex-row left-0">
        <div
          className="flex w-[50%] text-[13px] opacity-[.8]  text-[red] items-center cursor-pointer flex-col hover:opacity-[1] items-center justify-center text-center leading-[13px]"
          onClick={() => onDelete(item)}
        >
          <img
            alt="delete icon"
            src={deleteIcon}
            className="cursor-pointer leading-[13px] w-[19px] mr-[2px] mb-2"
          />
          Delete
        </div>
        <span
          onClick={() => onView(item)}
          className="flex w-[50%] text-[13px] opacity-[.8] text-[#096dea] items-center cursor-pointer flex-col hover:opacity-[1] items-center justify-center text-center leading-[13px]"
        >
          <img
            alt="view icon"
            src={chatIcon}
            className="cursor-pointer leading-[13px] w-[21px] mr-[2px] mb-2"
          />
          Chat
        </span>
      </div>
    </div>
  );
};

export default DocumentCard;
